export default __webpack_public_path__ + "static/media/about.a9ab3c35.jpg";